/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
//custom libraries
import { useMessageValue } from "../context";
import { REASON_CLICK_AWAY } from "../constants/message";

export const useMessageSnackbar = () => {
  const location = useLocation();
  const { message, setMessage } = useMessageValue();

  const handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === REASON_CLICK_AWAY) {
      return;
    }
    setMessage(null);
  };

  useEffect(() => {
    setMessage(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return {
    handleClose,
    message,
  };
};
